
import AddToCart from './add-to-cart';

export default AddToCart;
